import React, { useEffect, useState } from 'react';
import { useSubscription } from '@/shared/hooks/useSubscription'
import { useSelector } from 'react-redux';
import { getPayingCustomer } from '@/api/rtk/userSelectors'
import Button from '@/shared/components/AppButton'
import { useTranslation } from 'react-i18next';
import { LogOut } from 'lucide-react';
import { handleLogout } from '@/features/auth/lib/authSession'

const SubscriptionBar = ({noBorder}) => {
  const { daysLeft, trialEnded } = useSubscription();
  const payingCustomer = useSelector(getPayingCustomer);
  const { t } = useTranslation();
  const [trialMessage, setTrialMessage] = useState('');
  const [expiryMessage, setExpiryMessage] = useState('');
  const [buttonText, setButtonText] = useState('');

  useEffect(() => {
    // Set messages using i18next translation
    setTrialMessage(t('subscription.trialEndingSoon', { days: daysLeft }));
    setExpiryMessage(t('subscription.trialEndedMessage'));
    setButtonText(t('subscription.startPaidService'));
  }, [daysLeft, t]);

  if (payingCustomer === null || payingCustomer) {
    return null;
  }

  if (!trialEnded && daysLeft === null) {
    return null;
  }

  const showEndingSoon = !trialEnded && daysLeft > 0;

  return (
    <div
      className={`w-full p-5 md:px-4 md:py-[10px] sticky top-0 left-0 z-50 flex text-center sm:flex-row sm:text-left flex-col gap-2 justify-between items-center ${!noBorder && 'border-b'} ${showEndingSoon ? 'bg-orange-100 text-orange-600' : 'bg-red-100 text-red-600'
        }`}

    >
      <p>
        {showEndingSoon
          ? trialMessage
          : expiryMessage
        }
      </p>
      <div className='w-full sm:w-auto sm:min-w-[12rem] flex justify-center sm:justify-end items-center gap-3'>
        <a
        href="mailto:hey@mpassist.ai"
          className={`  text-white text-[14px] rounded-lg w-[83vw] sm:w-auto `}
      >
          <Button variant={showEndingSoon ? 'trial' : 'expire'} size='subscription'>
            <p>{buttonText}</p>
        </Button>
      </a>
        <button
          type="button"
          onClick={handleLogout}
          aria-label={t('navigation.logout')}
          title={t('navigation.logout')}
          className={`shrink-0 p-1.5 rounded-md ${showEndingSoon ? 'text-orange-600 hover:bg-orange-200/60' : 'text-red-600 hover:bg-red-200/60'}`}
        >
          <LogOut size={20} />
        </button>
      </div>
    </div>
  );
};

export default SubscriptionBar;
